import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'arrow-badge-down', 'IconArrowBadgeDown', [["path",{"d":"M17 13v-6l-5 4l-5 -4v6l5 4z","key":"svg-0"}]]);